import { SelectOption } from '@navstation-portal/shared/data-model/common';

export const DRY_DOCK_OR_REPAIR_OPERATION_TYPE = 'Dry Dock or Repair';

export const OPERATION_TYPE_OPTIONS: SelectOption[] = [
  { name: 'Loading', code: 'Loading' },
  { name: 'Discharging', code: 'Discharging' },
  { name: 'Loading and Discharging', code: 'Loading and Discharging' },
  { name: 'Idling', code: 'Idling' },
  { name: DRY_DOCK_OR_REPAIR_OPERATION_TYPE, code: DRY_DOCK_OR_REPAIR_OPERATION_TYPE },
] as const;

export const LOCATION_OPTIONS: SelectOption[] = [
  { name: 'In Port/Berth', code: 'In Port/Berth' },
  { name: 'SBM/SPM', code: 'SBM/SPM' },
  { name: 'Ship to Ship Transfer', code: 'Ship to Ship Transfer' },
] as const;

export const OPERATING_CODE_OPTIONS: SelectOption[] = [
  { code: '2', name: 'Normal Cruising' },
  { code: '3', name: 'Variable Speed' },
  { code: '6', name: 'Sailing in Ice (ice-classed)' },
  { code: '7', name: 'Endanger Safe Navigation' },
  { code: '8', name: 'STS' },
] as const;

export const BALLAST_CODE_OPTIONS: SelectOption[] = [
  { code: '1', name: 'Light Ballast Condition' },
  { code: '2', name: 'Partially Loaded' },
  { code: '3', name: 'Loaded' },
  { code: '4', name: 'Not Light Ballast Due To Heavy Weather' },
  { code: '5', name: 'Not Light Ballast Due To Hull Conditions' },
] as const;

export const OTHER_SPEED_STEAMING_OPTIONS: SelectOption[] = [
  { name: 'Not Applicable', code: '1' },
  { name: 'Reduced Visibility', code: '2' },
  { name: 'Heavy Vessel Congestion', code: '3' },
  { name: 'Adjust for Tide Window', code: '4' },
  { name: 'Testing Gear Prior to Arrival', code: '5' },
  { name: 'Whale Zones (regulatory)', code: '6' },
  { name: 'Other (add comments)', code: '7' },
] as const;

export const DEFAULT_OTHER_SPEED_STEAMING_OPTION = OTHER_SPEED_STEAMING_OPTIONS[0];

// The codes are the values V1 stores in operational.maneuvering_type.
export const MANEUVERING_TYPE_OPTIONS: SelectOption[] = [
  { code: 'arrival', name: 'Arriving to Port/Anchor' },
  { code: 'departure', name: 'Departure from Port/Anchor' },
  { code: 'maneuvering', name: 'Maneuvering' },
  { code: 'canal', name: 'Canal Transit' },
] as const;

export const getOtherSpeedSteamingOption = (code: string | undefined): SelectOption | undefined =>
  OTHER_SPEED_STEAMING_OPTIONS.find((option) => option.code === code);
